export * from './lib/components/metatrader-pswd-popup/metatrader-pswd-popup.component';
export * from './lib/components/account-tariffs/account-tariff/account-tariff.component';
export * from './lib/components/account-tariffs/account-tariffs.module';

export * from './lib/services/account-actions.service';

import { ROUTES } from './lib/routes';

export default ROUTES;
